import {
  APIProvider,
  ControlPosition,
  // biome-ignore lint/suspicious/noShadowRestrictedNames: <explanation>
  Map,
  Marker,
} from '@vis.gl/react-google-maps'
import React, { useEffect, useState } from 'react'

import { useAuthStore } from '@/modules/shared/stores/auth.store'

import type { NearbyCustomer } from '../../types/nearby-customers'
import { ClusteredCustomerMarkers } from './clustered-customer-markers'
import { DistanceControl } from './distance-control'

interface MemoizedMapProps {
  handleDistanceChange: (distance: number) => void
  customers: NearbyCustomer[]
  location: {
    lat: number
    lon: number
  }
}

export const MemoizedMap: React.FC<MemoizedMapProps> = React.memo(
  function MemoizedMap({ location, customers, handleDistanceChange }) {
    const [controlPosition] = useState<ControlPosition>(
      ControlPosition.LEFT_BOTTOM,
    )

    const [distance, setDistance] = useState(10)
    const { chaveMaps } = useAuthStore()

    useEffect(() => {
      handleDistanceChange(distance)
    }, [distance])
    return (
      <APIProvider apiKey={chaveMaps}>
        <Map
          style={{
            width: '100%',
            height: '100vh',
          }}
          mapId={'bf51a910020fa25a'}
          defaultCenter={{
            lat: location.lat,
            lng: location.lon,
          }}
          defaultZoom={15}
          controlSize={10}
          gestureHandling={'greedy'}
          disableDefaultUI
        >
          <DistanceControl
            controlPosition={controlPosition}
            distance={distance}
            onDistanceChange={(zoom) => setDistance(zoom)}
          />
          {customers && <ClusteredCustomerMarkers customers={customers} />}
          <Marker
            position={{
              lat: location.lat,
              lng: location.lon,
            }}
            title="Você está aqui"
          />
        </Map>
      </APIProvider>
    )
  },
)
